import {
  ControlledDropDown,
  ControlledMultiSelect,
  CustomButton,
  DOCUMENT_SECURITY_STATUS,
  DropdownType,
  FORMAT_PATTERN,
  formatPhoneNumber,
  FormInput,
  HTML_TYPE,
  isWordOrExcelOrCsvDocument,
  Modal,
  PaginatedControlledDropDown,
  PdfViewer,
  SvgCross,
  SvgDownloadGrey,
  SvgEdit,
} from '@ui-kit'
import { useEffect, useRef, useState } from 'react'
import {
  API_END_POINT,
  Attachment,
  axiosInstance,
  DataType,
  previewTemplatePayloadType,
  resetSelectedManualCommunicationState,
  sendTemplatePreviewPayload,
  hideLoader,
  addToaster,
  showLoader,
  ErrorResponse,
  getPreviewTemplateByCaseidAndTemplateId,
  fetchFaxIdCorrespondingData,
  selectedManualCommunication,
  getSearchedTemplatesinManualCommunicationApi,
  SEND_MANUAL_COMMUNICATION_CONSTANT,
  IEntityFieldType,
  getSubResources,
  faxOutboundDataType,
  AttachmentFaxOutboundType,
  CaseDocumentOption,
  sendCommunicationTemplateToRecipientApiV3,
  sendTemplatePayloadV3ApiEnhancementType,
  getRecipientsCorrespondingToEntityInstance,
  getRecipientsByEntityInstanceId,
  RecipientFaxOutbound,
  OrganizationOptions,
  WORKFLOW_UI_IDENTIFIER,
} from '@app-store'
import { useForm } from 'react-hook-form'
import {
  BUTTONS,
  COMM_TEMPLATE,
  ENTITY_NAME,
  LAYOUT_TYPE_NAMESPACE,
  MODAL_TYPES,
  NAMESPACES,
  NAMESPACES_MANUAL_COMMUNICATION,
} from '../../utils/constants'
import { isEmpty } from 'lodash'
import {
  fetchDocumentPdfByTemplateIdCaseId,
  fetchLayoutsByEntityName,
  getDownloadURL,
  getEntityName,
  loadCSSAndBuildHTMLForSendingCommunication,
  permissionObject,
  // makeEditableWithRedBackground,
  // removeEditableAndRedBackground,
} from '../../utils/helperFunctions'
import { v4 as uuid } from 'uuid'
import './SendManualCommunication.css'
import { AxiosError } from 'axios'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import DraggableAttachableList from './DraggableAttachableList'
import { SendManualCommunicationProps } from './SendManualCommunication.type'
import { CORRESPONDENCE_LOGS_STRINGS } from '../../utils/strings'
import { isReadOnlyUser } from '../../utils/permission'
import DocumentPopout from './DocumentPopout'
import { fetchFilePreviewUrlUsingFileName } from '../../apis/exportFile.api'
import { buildMailingAddress } from '../../utils/formatter'

const FaxOutboundTask: React.FC<SendManualCommunicationProps> = (
  props: SendManualCommunicationProps
) => {
  const previewAttachmentRef = useRef({ path: '', filename: '' })
  const faxOutboundFormData: faxOutboundDataType = {
    case_id: props.caseId,
    template_name: (props.preSelectedTemplateId as unknown as string) ?? '',
    mode_of_communication: '',
    program: props.programId,
    service: props.serviceId,
    caseDocuments: [],
  }

  const dispatch = useAppDispatch()
  const selectedTenantId = useAppSelector(
    (state: RootState) => state.authUser.selectedClientTenant?.id
  )
  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const [previewTemplateData, setPreviewTemplateData] =
    useState<selectedManualCommunication | null>(null)
  const caseKey = useAppSelector(
    (state: RootState) => state?.workflowData?.caseDetails?.caseId
  )
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions?.programPermissions
  )
  const caseData = useAppSelector(
    (state: RootState) => state.workflowData?.caseData
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const globalVariables = useAppSelector(
    (state: RootState) =>
      state?.workflowData?.workflowDefinition?.global_variables
  )
  const [currentPageTemplateName, setCurrentPageTemplateName] =
    useState<number>(0)
  const [sizeTemplateName, setSizeTemplateName] = useState<number>(20)
  const [previewDataWithLink, setPreviewDataWithLink] = useState<string | null>(
    null
  )
  const [previewUrl, setPreviewUrl] = useState<string>('')
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [allTemplates, setAllTemplates] = useState<DropdownType<string>[]>([])
  const [virtualScrollForTemplate, setVirtualScrollForTemplate] =
    useState<boolean>(true)
  const [editState, setEditState] = useState<boolean>(false)
  const [attachments, setAttachments] = useState<Attachment[]>([])
  const [previewData, setPreviewData] = useState<string>('')
  const [updatedData, setUpdatedData] = useState<string | null>(null)
  const [previewMap, setPreviewMap] = useState<{ [key: string]: string }>({})
  const [attachmentsKey, setAttachmentsKey] = useState<Attachment[]>()
  const [staticFileName, setStaticFileName] = useState<string>('')
  const [envelopeId, setEnvelopeId] = useState<string>('')
  const [toSmsFax, setToSmsFax] = useState<DropdownType<string>[]>([])
  const [caseDocumentOptions, setCaseDocumentOptions] = useState<
    DropdownType<string>[]
  >([])
  const downloadUrl = useRef<string>('')
  const [caseDocumentEntityData, setCaseDocumentEntityData] = useState<{
    entityId: number
    layoutId: number
  }>({ entityId: 0, layoutId: 0 })

  const [queuedFax, setQueuedFax] = useState<{
    id: string
    status: string
  } | null>(null)
  const [isSendButtonDisabled, setIsSendButtonDisabled] =
    useState<boolean>(true)

  const [modal, setModal] = useState<{ type: string; state: boolean }>({
    type: '',
    state: false,
  })
  const [documentType, setDocumentType] = useState<string>()
  const [attachmentData, setAttachmentData] = useState<string>('')
  const [attachmentBody, setAttachmentBody] = useState<Attachment | null>()

  const editableRef = useRef<HTMLDivElement>(null)

  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
    trigger,
  } = useForm({
    defaultValues: faxOutboundFormData,
  })
  const fetchAllTemplates = async (
    page: number,
    limit: number,
    value?: string,
    operator?: string
  ) => {
    try {
      dispatch(showLoader())
      const response = await getSearchedTemplatesinManualCommunicationApi(
        page,
        limit,
        [
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.PRODUCT_ID,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [parseInt(props?.productId)],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.PROGRAM_ID,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [parseInt(props?.programId)],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.SERVICE_ID,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [parseInt(props?.serviceId)],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.IS_ACTIVE,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [SEND_MANUAL_COMMUNICATION_CONSTANT.TRUE],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.TEMPLATE_NAME,
            operator: operator ?? SEND_MANUAL_COMMUNICATION_CONSTANT.CONTAINS,
            search_value: [value ?? ''],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.CORRESPONDENCE_TYPE,
            operator: 'IN',
            search_value: [
              props.task.identifier?.ui_identifier ===
              WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
                ? COMM_TEMPLATE.LETTER_UPPERCASE
                : COMM_TEMPLATE.FAX_CAPITAL,
            ],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.TEMPLATE_NAME,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.CONTAINS,
            search_value: ['coversheet'],
          },
        ]
      )
      const dataResponse = response.data.content
      if (!isEmpty(dataResponse)) {
        setVirtualScrollForTemplate(true)
        const array = dataResponse.map((item: DataType) => ({
          value: item?.id,
          label: item?.template_name,
          mode_of_communication: item?.correspondence_type,
          include_editable_text: item?.include_editable_text,
          program_services: item?.program_services,
        }))
        setAllTemplates((prevOptions) => {
          return [...(page === 0 ? [] : prevOptions ?? []), ...array]
        })
        setCurrentPageTemplateName(page)
        setSizeTemplateName(limit)
        return dataResponse
      } else {
        setVirtualScrollForTemplate(false)
      }
    } catch (error) {
      setVirtualScrollForTemplate(false)
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleTemplateOptionChange = (e: DropdownType<string>) => {
    const templateId = e?.value
    setIsSendButtonDisabled(true)
    if (previewDataWithLink) {
      setPreviewDataWithLink(null)
    }
    setValue('template_name', templateId)
    if (previewTemplateData) {
      setPreviewTemplateData(null)
      // setValue('to', []) //TODO: ensure whether to use or not
    }
  }

  const handleAttachmentDeleteClick = (itemToDelete: Attachment) => {
    const updatedAttachments = attachments.filter((item) => {
      if (itemToDelete.id !== undefined) {
        return item.id !== itemToDelete.id
      }
      return item.unique_attachment_name !== itemToDelete.unique_attachment_name
    })
    const selectedAttachments = watch('caseDocuments')
    const filteredCaseDocuments = selectedAttachments?.filter(
      (item) => item !== itemToDelete?.id
    )
    setValue('caseDocuments', filteredCaseDocuments)

    setAttachments(updatedAttachments)

    const updatedAttachmentsKey = updatedAttachments.map(
      (item: Attachment) => ({
        id: item?.id,
        unique_attachment_name: item?.unique_attachment_name,
        attachment_name: item?.attachment_name,
        attachment_document_type: item?.attachment_document_type,
        attachment_type: item?.attachment_type,
        attachment_document_id: item?.attachment_document_id,
        include_editable_text: item?.include_editable_text,
        contains_docusign: item?.contains_docusign,
        awsFileName: item?.awsFileName,
        ...(item?.path ? { path: item.path } : {}),
      })
    )

    setAttachmentsKey(updatedAttachmentsKey)
  }

  const sendCommunicationTemplateFunction = async (
    payload: sendTemplatePayloadV3ApiEnhancementType
  ) => {
    try {
      dispatch(showLoader())
      const response = await sendCommunicationTemplateToRecipientApiV3(
        {
          sendPayload: payload,
          envelopeId: envelopeId,
        },
        caseData?.programs?.id?.toString(),
        caseData?.services?.id?.toString()
      )
      if (response.data) {
        setQueuedFax({
          id: response?.data?.id,
          status: response?.data?.status,
        })

        await props?.updateTaskResource?.(props?.task, {
          resource_id: response?.data?.id,
          template_id: watch('template_name'),
        })

        dispatch(
          addToaster({
            message: `${payload?.correspondence_type}${COMM_TEMPLATE.SUCCESSFULLY_QUEUED}`,
            type: 'success',
            id: uuid(),
          })
        )
      }

      dispatch(resetSelectedManualCommunicationState())
      setEnvelopeId('')
    } catch (err) {
      console.error(err)
      if (
        ((err as AxiosError)?.response?.data as ErrorResponse)?.message ===
        COMM_TEMPLATE?.CONFLICT_RECIPIENT_API_MESSAGE
      ) {
        dispatch(
          addToaster({
            message: COMM_TEMPLATE?.CONFLICT_RECIPIENT_TOASTER_MESSAGE,
            type: 'error',
            id: uuid(),
          })
        )
      } else {
        dispatch(
          addToaster({
            message: `${COMM_TEMPLATE.FAILED_TO_QUEUE} ${payload?.correspondence_type}`,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } finally {
      dispatch(hideLoader())
    }
  }

  const sendCommunicationTemplate = async () => {
    const result = await trigger()
    if (!result) return
    const sendEdit: sendTemplatePreviewPayload = {
      type: 0,
      editableValues: previewMap,
    }
    const sendPayload = [sendEdit]
    if (attachmentsKey === undefined) {
      setAttachmentsKey(attachments)
    }
    const finalAttachments = (attachmentsKey ?? attachments)?.map(
      (item: Attachment) => ({
        attachment_name: item?.attachment_name,
        attachment_document_type: item?.attachment_document_type,
        attachment_type: CORRESPONDENCE_LOGS_STRINGS.CUSTOM,
        attachment_document_id: item?.attachment_document_id,
        include_editable_text: item?.include_editable_text,
        contains_docusign: item?.contains_docusign,
        ...(item?.path ? { path: `${item?.path}/${item?.awsFileName}` } : {}),
      })
    )
    if (!finalAttachments?.length) {
      dispatch(
        addToaster({
          message: COMM_TEMPLATE?.ATTACHMENT_VALIDATION_WHILE_SENDING_MSG,
          type: 'error',
          id: uuid(),
        })
      )
      return
    }
    const additionalFields = {
      recipient_to: [watch('to') ?? ''],
      correspondence_type:
        props.task.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
          ? COMM_TEMPLATE.LETTER_UPPERCASE
          : COMM_TEMPLATE.FAX_CAPITAL,
      attachment: finalAttachments,
      recipient_cc: [],
      recipient_bcc: [],
    }
    const entityName = getEntityName(
      (props?.task?.organization_view?.organization_type as string) ??
        (props?.task?.requestor_view?.entity_type as string)
    )
    const modifiedViewObject = [
      {
        name: [
          {
            value:
              props?.task?.organization_view?.organization_name ??
              props?.task?.requestor_view?.name ??
              '',
          },
        ],
        recipient: watch('to'),
        recipient_label: `case.${entityName}`,
        entity: entityName,
        type: 'to',
        entity_name: entityName,
        record_ids: [
          props?.task?.organization_view?.record_id ??
            props.task?.requestor_view?.record_id,
        ],
        record_keys: [
          props?.task?.organization_view?.record_key ??
            props.task?.requestor_view?.record_key,
        ],
      },
    ]
    const payload = {
      case_id: parseInt(watch('case_id')),
      template_id: parseInt(watch('template_name')),
      service_id: parseInt(props?.serviceId),
      product_id: parseInt(props?.productId),
      program_id: parseInt(props?.programId),
      body:
        loadCSSAndBuildHTMLForSendingCommunication(
          previewTemplateData?.body_type === HTML_TYPE.DOCX_UPPPERCASE
            ? previewTemplateData?.body ?? ''
            : previewData,
          previewTemplateData?.body_type
        ) ?? '',
      editable_fields: sendPayload,
      view_object: modifiedViewObject,
      ...additionalFields,
    }
    sendCommunicationTemplateFunction(payload)
  }

  const onSubmit = async () => {
    const data = watch()
    try {
      dispatch(showLoader())
      const payload: previewTemplatePayloadType = {
        caseId: parseInt(data?.case_id),
        templateId: parseInt(data?.template_name),
        isEditable: true,
        programId: parseInt(data?.program),
      }
      const response = await getPreviewTemplateByCaseidAndTemplateId(
        payload,
        caseData?.programs?.id?.toString(),
        caseData?.services?.id?.toString()
      )
      if (props.task.identifier?.use_dynamic_receiver) {
        const orgName = props.task.identifier.template?.dynamic_fax_name ?? ''
        const orgNumber =
          props.task.identifier.template?.dynamic_fax_number ?? ''
        const modified = [...response.data.view_object]
        modified[0] = {
          ...modified[0],
          name: [
            {
              key: 'receiver_name',
              value: orgName,
            },
          ],
          recipient: orgNumber,
          recipient_label: 'receiver_fax',
        }
        response.data.view_object = modified
      }
      if (response) {
        setIsSendButtonDisabled(false)
      }

      if (response.data.body_type === HTML_TYPE.DOCX_UPPPERCASE) {
        try {
          const urlResponse = await fetchFilePreviewUrlUsingFileName(
            response.data.body ?? ''
          )
          if (urlResponse?.data?.url) {
            setPreviewData(urlResponse.data.url)
          }
        } catch (error) {
          console.error(CORRESPONDENCE_LOGS_STRINGS.API_ERROR, error)
          setPreviewData('')
        }
      }

      setPreviewTemplateData(response.data)
      setUpdatedData(null)
      setEditState(false)
    } catch (error) {
      console.error(error)
      setIsSendButtonDisabled(true)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchFilePreviewUrl = async (path: string, fileName: string) => {
    try {
      dispatch(showLoader())
      const response = await axiosInstance.get(
        `${API_END_POINT.CORE}v1/files/generate-download-url?fileName=${path}${
          fileName ? '/' : ''
        }${fileName ?? ''}`,
        {
          headers: {
            'x-tenantid': selectedTenantId,
          },
        }
      )
      if (response.data) {
        setPreviewUrl(response.data?.url)
        downloadUrl.current = response.data?.url
        return response.data?.url
      }
    } catch (error) {
      console.error(CORRESPONDENCE_LOGS_STRINGS.API_ERROR, error)
      setPreviewUrl('')
      downloadUrl.current = ''
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleViewClick = async (filename: string, path?: string) => {
    previewAttachmentRef.current = { filename, path: path ?? '' }
    await fetchFilePreviewUrl(path ?? '', filename ?? '')
    setIsOpenModal(true)
    setStaticFileName(filename)
  }

  const getButtonText = () =>
    props?.task?.resource_id ? BUTTONS?.RESEND : BUTTONS.SEND

  const fetchStatus = async () => {
    try {
      const responseStatus = await fetchFaxIdCorrespondingData(
        Number(props?.task?.resource_id)
      )
      if (responseStatus?.data) {
        setQueuedFax({
          id: responseStatus?.data?.id,
          status: responseStatus?.data?.category_status_id,
        })
        setValue('template_name', responseStatus?.data?.template_id)
        setValue('to', responseStatus?.data?.view_object?.[0]?.recipient)
        const attachments = responseStatus?.data?.document_entities?.attachment
          ?.filter(
            (item: AttachmentFaxOutboundType) =>
              item?.description !== 'cover_sheet'
          )
          .map(transformToAttachment)

        setAttachments(attachments)
        if (responseStatus.data.body_type === HTML_TYPE.DOCX_UPPPERCASE) {
          try {
            const urlResponse = await fetchFilePreviewUrlUsingFileName(
              responseStatus.data.body ?? ''
            )
            if (urlResponse?.data?.url) {
              setPreviewData(urlResponse.data.url)
            }
          } catch (error) {
            console.error(CORRESPONDENCE_LOGS_STRINGS.API_ERROR, error)
            setPreviewData('')
          }
        }
        setPreviewTemplateData(responseStatus?.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getClassOnEditState = (editState: boolean) =>
    editState ? 'bg-accent-0 with-shadow' : 'bg-accent-100'

  const handleSave = () => {
    if (!isEmpty(editableRef.current)) {
      const updatedHtml = editableRef?.current?.innerHTML

      const parser = new DOMParser()
      const doc = parser.parseFromString(updatedHtml, 'text/html')
      const editableDivs = doc.querySelectorAll('div')

      const initialPreviewMap: { [key: string]: string } = {}

      editableDivs.forEach((div) => {
        if (div.className.startsWith('editable')) {
          const innerText = div.innerText

          div.innerHTML = `<span style="background-color: inherit" contenteditable="false">${innerText}</span>`

          const className = div.getAttribute('class')?.toString()
          if (className) {
            initialPreviewMap[className] = innerText
          }
        }
      })
      setPreviewMap((prevMap) => ({ ...prevMap, ...initialPreviewMap }))
      const updatedHtmlWithChanges = doc.documentElement.innerHTML
      setUpdatedData(updatedHtmlWithChanges)
    }
    setEditState(false)
  }

  // const getFormatedHtmlData = (editState: boolean, previewData: string) =>
  //   editState
  //     ? makeEditableWithRedBackground(previewData)
  //     : removeEditableAndRedBackground(previewData)

  useEffect(() => {
    const fetchCaseDocumentEntityLayouts = async () => {
      const caseDocumentEntityData = await fetchLayoutsByEntityName(
        dispatch,
        ENTITY_NAME.CASE_DOCUMENTS_LOWER
      )
      const layoutId = caseDocumentEntityData?.content?.find(
        (item: IEntityFieldType) =>
          item?.type === LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING
      )?.id
      const entityId = caseDocumentEntityData?.content?.[0]?.entity_id
      setCaseDocumentEntityData({ layoutId: layoutId, entityId: entityId })
    }
    fetchCaseDocumentEntityLayouts()
  }, [])

  const transformToAttachment = (
    data: AttachmentFaxOutboundType,
    attachmentsId: number
  ) => {
    return {
      attachment_name: data.alias ?? data?.name ?? '',
      attachment_document_id: data?.exp ?? 0,
      attachment_type: data.extension ?? '',
      attachment_url: data.name ?? '',
      attachment_document_type: COMM_TEMPLATE.STATIC_DOCUMENT_UPPERCASE,
      awsFileName: data?.name ?? '',
      attachment_data: data.name ?? '',
      contains_docusign: data?.metaData?.isDocusign ?? false,
      id: `${attachmentsId}_${data?.name}`,
      path: data?.path?.replace(/\/+$/, '') ?? '',
    }
  }

  const handleCaseAttachmentsChange = (e: DropdownType<number | null>[]) => {
    setAttachments(
      (e as unknown as CaseDocumentOption[])?.map((item) => item?.attachments)
    )
    const tempAttachments = (e as unknown as CaseDocumentOption[])
      ?.map((item) => item?.attachments)
      ?.map((item: Attachment) => {
        return {
          id: item?.id,
          attachment_name: item?.attachment_name,
          attachment_document_type: item?.attachment_document_type,
          attachment_type: item?.attachment_type,
          attachment_document_id: item?.attachment_document_id,
          awsFileName: item?.awsFileName,
          include_editable_text: item?.include_editable_text ?? false,
          contains_docusign: item?.contains_docusign,
          ...(item?.path ? { path: item?.path } : {}),
        }
      })
    setAttachmentsKey(tempAttachments)
    setValue(
      'caseDocuments',
      (e as unknown as CaseDocumentOption[])?.map((item) => item?.value)
    )
  }

  const handleAttachmentEditClick = async (item: Attachment, type: string) => {
    setDocumentType(item?.attachment_document_type)
    if (
      item?.attachment_document_type === COMM_TEMPLATE.STATIC_DOCUMENT_UPPERCASE
    ) {
      if (isWordOrExcelOrCsvDocument(item?.attachment_name)) {
        await fetchFilePreviewUrl(item?.path ?? '', item?.awsFileName ?? '')
        getDownloadURL(
          dispatch,
          props?.caseId,
          downloadUrl.current,
          item?.attachment_name
        )
      } else {
        handleViewClick(item?.awsFileName ?? '', item?.path ?? '')
      }
    } else {
      const attachmentInfo = previewTemplateData?.attachment?.find(
        (value) => value.id === item?.id
      )
      try {
        dispatch(showLoader())
        const pdfData = await fetchDocumentPdfByTemplateIdCaseId(
          parseInt(props?.caseId) ?? 0,
          item.attachment_document_id ?? 0
        )
        if (pdfData?.documentType === COMM_TEMPLATE.DOCX_UPPERCASE) {
          handleViewClick(item?.attachment_name, pdfData?.pdfData)
          return
        }
        setTimeout(() => {
          setAttachmentData(pdfData?.pdfData)
        }, 0)
      } catch (error) {
        console.error('Error fetching PDF data:', error)
        setAttachmentData('')
      } finally {
        dispatch(hideLoader())
      }
      if (attachmentInfo || attachmentData) {
        setModal({
          type: type === MODAL_TYPES.LINK ? MODAL_TYPES.VIEW : MODAL_TYPES.EDIT,
          state: true,
        })
        setTimeout(() => {
          setAttachmentBody(attachmentInfo)
        }, 0)
      }
    }
  }

  const hasManagePermission = () => {
    return permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      props?.task,
      userId ?? ''
    )
  }

  useEffect(() => {
    if (!caseDocumentEntityData?.entityId || !caseDocumentEntityData?.layoutId)
      return

    const relationShipIdentifier = relationshipTree
      ?.find(
        (item) =>
          item?.entity_id?.toString() ===
          caseDocumentEntityData?.entityId?.toString()
      )
      ?.relation_identifier?.toString()

    const getCaseDocumentsAttachedToRecord = async () => {
      const data = await getSubResources(
        ENTITY_NAME.CASE_DOCUMENTS_LOWER,
        caseDocumentEntityData?.entityId?.toString(),
        caseDocumentEntityData?.layoutId?.toString(),
        relationShipIdentifier ?? '',
        false,
        props?.caseId,
        0,
        2000,
        undefined,
        [
          {
            criteria: [
              {
                direction: 'ASC',
                field_name: 'record_status',
                operation: 'LIKE',
                values: [],
              },
            ],
          },
        ],
        ['name', 'case_document_type', 'document_upload'],
        {}
      )
      return data?.data?.content
    }

    ;(async () => {
      const caseDocumentData = await getCaseDocumentsAttachedToRecord()
      const caseDocumentOptionsArray = caseDocumentData.flatMap(
        (item: {
          id: number
          name: string
          document_upload: { attachment: AttachmentFaxOutboundType[] }
        }) =>
          item.document_upload?.attachment
            ?.filter(
              (attachment: AttachmentFaxOutboundType) =>
                attachment.status === DOCUMENT_SECURITY_STATUS.READY
            )
            ?.map((attachment: AttachmentFaxOutboundType) => ({
              value: `${item.id}_${attachment.name}`,
              label: `${item.name} - ${attachment.alias ?? attachment.name}`,
              attachments: transformToAttachment(attachment, item?.id),
            })) || [] // fallback if attachments are undefined/null
      )

      setCaseDocumentOptions(caseDocumentOptionsArray)
    })()
  }, [caseDocumentEntityData])

  useEffect(() => {
    setEnvelopeId('')
  }, [watch('template_name'), watch])

  useEffect(() => {
    if (!previewTemplateData) {
      setUpdatedData(null)
      setEditState(false)
    }
  }, [previewTemplateData])

  useEffect(() => {
    if (previewTemplateData?.body_type !== HTML_TYPE.DOCX_UPPPERCASE) {
      setPreviewData(
        updatedData ?? previewDataWithLink ?? previewTemplateData?.body ?? ''
      )
    }
  }, [editState, previewTemplateData])

  useEffect(() => {
    if (props?.productId)
      fetchAllTemplates(currentPageTemplateName, sizeTemplateName, '')
  }, [selectedTenantId, props?.productId])

  useEffect(() => {
    if (props?.task?.resource_id) {
      fetchStatus()
    }
  }, [props?.task?.resource_id])

  useEffect(() => {
    setValue('to', '')

    const fetchRecipientOptions = async () => {
      const recordId =
        props?.task?.requestor_view?.record_id ??
        props?.task?.organization_view?.record_id
      const entityType =
        props?.task?.requestor_view?.entity_type ??
        (props?.task?.organization_view as OrganizationOptions)
          ?.organization_type
      if (recordId) {
        const entityName = getEntityName(entityType ?? '')
        if (
          entityName &&
          (entityName === 'contacts' || entityName === 'providers') &&
          props.task.identifier?.ui_identifier ===
            WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
        ) {
          dispatch(
            addToaster({
              message: COMM_TEMPLATE.OUTBOUND_MAIL_PATIENT_ONLY_MESSAGE,
              type: 'error',
              id: uuid(),
            })
          )
          return
        }
        const basePayload =
          globalVariables?.[entityName as 'contacts' | 'patients' | 'providers']

        if (!basePayload) return
        const entityPayload = {
          ...basePayload,
          select:
            props.task.identifier?.ui_identifier ===
            WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
              ? [NAMESPACES.C_PATIENT_ADDRESS]
              : entityName === ENTITY_NAME.PATIENTS
              ? [NAMESPACES.C_PATIENT_PHONE]
              : basePayload?.select,
        }
        const payload: getRecipientsByEntityInstanceId = {
          id: recordId,
          apiPayload: entityPayload ?? {
            select: [],
            entity_name: '',
            related_entities: {},
          },
        }
        const response = await getRecipientsCorrespondingToEntityInstance(
          payload
        )
        return response?.data?.[
          props.task.identifier?.ui_identifier ===
          WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
            ? NAMESPACES.C_PATIENT_ADDRESS
            : entityName === ENTITY_NAME.PATIENTS
            ? NAMESPACES.C_PATIENT_PHONE
            : basePayload?.select[0]
        ]
      }
    }
    ;(async () => {
      const recipientResponse = await fetchRecipientOptions()
      let recipientOptions
      if (
        props.task.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
      ) {
        recipientOptions =
          recipientResponse
            ?.filter((item: RecipientFaxOutbound) => item.is_preferred)
            ?.map((item: RecipientFaxOutbound) => {
              const label = buildMailingAddress(item)
              if (!label) return null

              return {
                label,
                value: label.replace(` ${COMM_TEMPLATE.PRIMARY}`, ''),
              }
            })
            ?.filter(Boolean) ?? []
      } else {
        recipientOptions = recipientResponse?.map(
          (item: RecipientFaxOutbound) => ({
            label: item?.is_preferred
              ? formatPhoneNumber(
                  item.phone_number,
                  FORMAT_PATTERN.PHONE_INPUT
                ) + ` ${COMM_TEMPLATE.PRIMARY}`
              : formatPhoneNumber(
                  item?.phone_number,
                  FORMAT_PATTERN.PHONE_INPUT
                ),
            value: item.phone_number,
          })
        )
      }
      setToSmsFax(recipientOptions)
    })()
  }, [
    props?.task?.requestor_view?.record_id,
    props?.task?.organization_view?.record_id,
  ])

  return (
    <div className="flex flex-col font-primary bg-accent-0">
      <form className="py-4" method="POST" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex gap-2 ml-auto mr px-3 justify-end">
          <CustomButton
            dataQaId="generate-send-enable-disable"
            disabled={
              isReadOnlyUser() ||
              !watch('template_name') ||
              !!props?.task?.resource_id ||
              !hasManagePermission()
            }
            isFilled={true}
            className={`h-[2.375rem] flex gap-1 items-center`}
            type="button"
            tabIndex={props?.tabIndexOffset}
            onClick={() => onSubmit()}
            key={watch('template_name')?.toString()}
          >
            <span className={`font-primary`}>
              {COMM_TEMPLATE.GENERATE_PREVIEW}
            </span>
          </CustomButton>
          <CustomButton
            key={
              (watch('to') ?? [])?.toString() +
              (watch('letter_address') ?? [])?.toString()
            }
            dataQaId="send-communication-template"
            type="button"
            color="primary"
            widthClass="w-[5.563rem]"
            className="text-xs flex mb-4 mr-2"
            isFilled={true}
            onClick={sendCommunicationTemplate}
            tabIndex={props?.tabIndexOffset}
            disabled={
              isReadOnlyUser() ||
              isSendButtonDisabled ||
              !!props?.task?.resource_id ||
              !hasManagePermission()
            }
          >
            <span className="text-xs font-light">{getButtonText()}</span>
          </CustomButton>
        </div>
        <div className="pl-3 pt-3 pr-3 bg-accent-0 shadow-md pb-3">
          <div className="grid grid-cols-3 gap-4">
            <div className="col-span-1">
              <PaginatedControlledDropDown
                name={`template_name`}
                label={COMM_TEMPLATE.COVERSHEET}
                errors={errors}
                control={control}
                onChange={handleTemplateOptionChange}
                options={allTemplates ?? []}
                required={true}
                dataQaId={'template_name'}
                page={currentPageTemplateName}
                limit={sizeTemplateName}
                fetchOptions={fetchAllTemplates}
                virtualScroll={virtualScrollForTemplate}
                tabIndex={props?.tabIndexOffset}
                disabled={props?.isDisabled || !hasManagePermission()}
              />
            </div>
            <div>
              <ControlledDropDown
                options={toSmsFax}
                name="to"
                label={
                  props.task.identifier?.ui_identifier ===
                  WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
                    ? COMM_TEMPLATE.RECIPIENT_MAILING_ADDRESS
                    : COMM_TEMPLATE.RECIPIENTS_FAX_NUMBER
                }
                // noOfChips={3}
                isSearchable={false}
                errors={errors}
                control={control}
                required={true}
                onChange={(value: DropdownType<string>) => {
                  // const valuesArray = e.map((item) => item.value)
                  setValue('to', value?.value, { shouldValidate: true })
                }}
                dataQaId={'to'}
                disabled={props?.isDisabled || !hasManagePermission()}
                // modifiedTooltip={tooltipArray?.to} TODO
                tabIndex={props?.tabIndexOffset}
              />
            </div>

            <div>
              <FormInput
                name="fax_status"
                disabled
                value={queuedFax?.status ?? '--'}
                label={COMM_TEMPLATE?.FAX_TRANSMISSION_STATUS}
                tabIndex={props?.tabIndexOffset}
              />
            </div>
          </div>
          <div className="mt-4">
            {!props?.isDisabled ? (
              <ControlledMultiSelect
                options={caseDocumentOptions}
                name="caseDocuments"
                label={COMM_TEMPLATE.CASE_ATTACHMENTS}
                isSearchable={true}
                errors={errors}
                noOfChips={3}
                control={control}
                disabled={props?.isDisabled || !hasManagePermission()}
                required={false}
                onChange={handleCaseAttachmentsChange}
                dataQaId={'case_documents_dropdown'}
                tabIndex={props?.tabIndexOffset}
              />
            ) : null}
          </div>

          <DraggableAttachableList
            label={
              props.task.identifier?.ui_identifier ===
              WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
                ? COMM_TEMPLATE.ATTACHMENTS
                : COMM_TEMPLATE?.FAX_ATTACHMENTS
            }
            setAttachmentsKey={setAttachmentsKey}
            setAttachments={setAttachments}
            attachments={attachments}
            handleViewClick={handleViewClick}
            handleAttachmentEditClick={handleAttachmentEditClick}
            handleAttachmentDeleteClick={handleAttachmentDeleteClick}
            tabIndexOffset={props?.tabIndexOffset}
            hideUploadButton
            isViewMode={!!props?.task?.resource_id}
          />
        </div>
        {previewTemplateData && (
          <div className="bg-accent-0 shadow-md pl-3 pr-3 pb-3 ">
            <div
              className={`template-data ${getClassOnEditState(
                editState
              )} mt-4 p-3 border-t-[2px] border-t-accent-900`}
            >
              <div className="flex justify-between">
                <span className="text-base">
                  {!editState && COMM_TEMPLATE.COVERSHEET_PREVIEW}
                  {editState && COMM_TEMPLATE.REVIEW_EDITABLE_TEXT}
                </span>
                {previewTemplateData?.include_editable_text && !editState && (
                  <button
                    onClick={() => {
                      setEditState(true)
                    }}
                  >
                    {<SvgEdit />}
                  </button>
                )}
                {editState && (
                  <div className="flex gap-4">
                    <CustomButton
                      dataQaId="cancel-edit-body-preview"
                      type="button"
                      color="primary"
                      widthClass="w-[5.563rem]"
                      className="text-xs"
                      isFilled={false}
                      onClick={() => {
                        setEditState(false)
                        setPreviewData(
                          previewDataWithLink ?? previewTemplateData.body
                        )
                      }}
                    >
                      <span className="text-xs font-light">
                        {NAMESPACES_MANUAL_COMMUNICATION.CANCEL}
                      </span>
                    </CustomButton>
                    <CustomButton
                      dataQaId="save-edit-updated-html"
                      type="button"
                      color="primary"
                      widthClass="w-[5.563rem]"
                      className="text-xs"
                      isFilled={true}
                      onClick={handleSave}
                    >
                      <span className="text-xs font-light">
                        {NAMESPACES_MANUAL_COMMUNICATION.SAVE}
                      </span>
                    </CustomButton>
                  </div>
                )}
              </div>
              {
                <div className="flex editer-wrap justify-center">
                  <div className="w-[49.5rem] min-h-[21cm] with-shadow ck-content document-editor__editable-container bg-accent-0 p-4 border-t-2 border-secondary-450">
                    {/* <div
                      ref={editableRef}
                      dangerouslySetInnerHTML={{
                        __html: getFormatedHtmlData(editState, previewData),
                      }}
                      className="bg-inherit overflow-x-auto font-primary ck-content leading-4 rounded-lg"
                    /> */}
                    <PdfViewer
                      pdfUrl={previewData}
                      isBase64={
                        previewTemplateData?.body_type !==
                        HTML_TYPE.DOCX_UPPPERCASE
                      }
                      allowZoom={false}
                      showPageNumber={false}
                      defaultZoomScale={1.3}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        )}
      </form>
      {isOpenModal && (
        <div className="a4modal">
          <Modal
            isOpen={true}
            closeModal={() => {
              setIsOpenModal(false)
            }}
            showCloseButton={false}
            isDragable
            isBackdropInteractive
          >
            <div className="flex flex-col">
              <div className="flex justify-between items-center">
                <div className="font-bold text-lg mr-4">
                  <span>{COMM_TEMPLATE?.VIEW_DOCUMENT} - </span>
                  <span>{staticFileName}</span>
                </div>

                <div className="flex items-center gap-3">
                  <DocumentPopout
                    source={previewUrl}
                    generateUrl={async () =>
                      await fetchFilePreviewUrl(
                        previewAttachmentRef.current.path,
                        previewAttachmentRef.current.filename
                      )
                    }
                  />
                  <button
                    className="cursor-pointer"
                    onClick={() =>
                      getDownloadURL(
                        dispatch,
                        caseKey ?? watch('case_id'),
                        previewUrl,
                        staticFileName
                      )
                    }
                    data-qa-id="download-file"
                  >
                    <SvgDownloadGrey />
                  </button>
                  <button
                    className="flex items-center justify-center h-[1rem] w-[1rem] cursor-pointer"
                    onClick={() => setIsOpenModal(false)}
                  >
                    <SvgCross height={'0.875rem'} width={'0.875rem'} />
                  </button>
                </div>
              </div>
              <div className="px-3 py-[1rem] border border-border-100 ck-content doc-wrap-height mt-4">
                <iframe
                  title="file preview"
                  src={`${previewUrl}#toolbar=0&navpanes=0`}
                  style={{ border: 0 }}
                  height="500"
                  className="w-full max-w-full min-w-[800px]"
                />
              </div>
            </div>
          </Modal>
        </div>
      )}
      {modal.state && (
        <div className="a4modal">
          <Modal
            isOpen={modal.state}
            closeModal={() => setModal({ type: '', state: false })}
            showCloseButton={false}
            closeModalOnOutsideClick={false}
            className="border rounded-none"
            isDragable
            isBackdropInteractive
          >
            <div className="flex flex-col w-[49.5rem]">
              <div className="flex justify-between items-center">
                <div className="font-medium text-lg">
                  <span>{COMM_TEMPLATE.VIEW_DOCUMENT} - </span>

                  <span>{attachmentBody?.attachment_name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <DocumentPopout
                    source={attachmentData}
                    generateUrl={async () =>
                      await fetchFilePreviewUrl(
                        previewAttachmentRef.current.path,
                        previewAttachmentRef.current.filename
                      )
                    }
                  />
                  <button
                    className="cursor-pointer"
                    onClick={() =>
                      getDownloadURL(
                        dispatch,
                        caseKey ?? watch('case_id'),
                        attachmentData,
                        attachmentBody?.attachment_name,
                        documentType
                      )
                    }
                    data-qa-id="download-file"
                  >
                    <SvgDownloadGrey />
                  </button>

                  <button
                    className="flex items-center justify-center h-[1rem] w-[1rem] cursor-pointer"
                    onClick={() => setModal({ type: '', state: false })}
                  >
                    <SvgCross height={'0.875rem'} width={'0.875rem'} />
                  </button>
                </div>
              </div>
              <div className="flex flex-col justify-between mt-4">
                {modal.type !== MODAL_TYPES.EDIT && (
                  <div
                    className={`border border-accent-200 w-full document-editor__editable-container-view mt-2 bg-white overflow-clip`}
                  >
                    <PdfViewer
                      pdfUrl={attachmentData}
                      isBase64
                      allowZoom={false}
                      showPageNumber={false}
                      defaultZoomScale={1.3}
                    />
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}
//TODO: use later
// const NegativeScreen = ({ message }: { message: string }) => {
//   return (
//     <div className="h-[25.75rem] mt-[2.125rem] mx-0 border border-accent-100 rounded-lg">
//       <div className="flex flex-col justify-center items-center gap-[1.5rem] h-full">
//         <div>
//           <SvgWarningNew />
//         </div>
//         <div className="font-light text-xs">{message}</div>
//       </div>
//     </div>
//   )
// }

export default FaxOutboundTask
